import { call, put, delay } from 'redux-saga/effects';
import { fetchProtectedData } from '../utils/fetchProtectedData';
import { AxiosError } from 'axios';
import { Methods } from '../constants/constants';
import { Action } from 'redux';
import { IDataInput, IResponseGeneratorGen } from '../interface/interfaces';

function* workerSaga<T, P extends IDataInput>(
    action: Action & { payload: P },
    successAction: (data: T) => Action,
    failureAction: (error: string) => Action,
    method: Methods,
    isProtected: boolean,
    hasURLRoot: boolean,
    isChat: boolean,
) {
    let attempt = 0;
    const maxAttempt = 3;
    const delayFetching = 2000;

    const urlSplit = action.payload.url;
    // const urlEndWidth = urlSplit[urlSplit.length - 1].toUpperCase();
    while (attempt < maxAttempt) {

        try {
            const response: IResponseGeneratorGen<T> = yield call(fetchProtectedData, method, action.payload, isProtected, hasURLRoot, isChat);
            const data = response.data;
            yield put(successAction(data));
            // eslint-disable-next-line no-console
            console.log(
                `%c Attempt ${attempt + 1} of ${maxAttempt} for fetching ${urlSplit} successful.`,
                'background:rgba(0,255,0,.2); padding:.5rem; border:1px solid green; color: rgb(0,255,100); border-radius:.3rem',
            );
            return; // prekinuti petlju ako fetch uspe
        } catch (err) {
            attempt++;
            if (attempt >= maxAttempt) {
                let error;
                if (err instanceof AxiosError) {
                    error = err.message;
                } else {
                    error = err;
                }

                yield put(failureAction(`Failed to retrieve data: ${error}`));
            } else {
                // eslint-disable-next-line no-console
                console.log(
                    `%c Fetching attempt ${attempt} for ${urlSplit} failed. Retrying in ${delayFetching / 1000} seconds...`,
                    'background:rgba(255,0,0,.2); padding:.5rem; border:1px solid red; color: rgb(255,70,50); border-radius:.3rem',
                );
                yield delay(delayFetching); // čekanje pre ponovnog pokušaja
            }
        }
    }
}

export default workerSaga;
